import { useNavigate } from "react-router-dom";
import { Ban, GitBranch, Clock } from "lucide-react";
import { TypeIcon, PriorityIcon, Avatar } from "./workMeta";
import { fmtH, fmtMoney } from "./WorkLog";

export default function WorkCard({ item, compact, dragHandleProps, className = "", currency }) {
  const navigate = useNavigate();
  const hasHours = item.estimate_hours != null || item.logged_hours > 0;
  return (
    <div
      {...(dragHandleProps || {})}
      data-testid={`work-card-${item.key}`}
      onClick={() => navigate(`/work/${item.key}`)}
      className={`bg-white border rounded-md p-2.5 text-sm shadow-sm hover:shadow-md hover:border-[#1E3A8A]/40 transition-[box-shadow,border-color] cursor-pointer ${className}`}
    >
      <div className="flex items-start gap-2">
        <TypeIcon type={item.type} />
        <div className="flex-1 min-w-0">
          <div className="leading-snug line-clamp-2">{item.title}</div>
          {!compact && item.labels?.length > 0 && (
            <div className="flex flex-wrap gap-1 mt-1.5">
              {item.labels.slice(0, 3).map((l) => <span key={l} className="text-[10px] bg-secondary rounded px-1.5 py-0.5 text-muted-foreground">{l}</span>)}
            </div>
          )}
        </div>
      </div>
      <div className="flex items-center justify-between gap-2 mt-2">
        <div className="flex items-center gap-1.5 text-[11px] text-muted-foreground">
          <span className="font-medium text-foreground">{item.key}</span>
          <PriorityIcon priority={item.priority} />
          {item.is_blocked && <span className="inline-flex items-center gap-0.5 text-[#991B1B]" title="Blocked"><Ban className="h-3 w-3" /></span>}
          {item.child_count > 0 && <span className="inline-flex items-center gap-0.5" title="Children"><GitBranch className="h-3 w-3" />{item.child_count}</span>}
        </div>
        <div className="flex items-center gap-1.5">
          {item.story_points != null && <span className="text-[10px] font-semibold bg-secondary rounded-full px-1.5 py-0.5" title="Story points">{item.story_points}</span>}
          <Avatar name={item.assignee_name} />
        </div>
      </div>
      {(hasHours || item.price != null) && !compact && (
        <div className="flex items-center justify-between gap-2 mt-1.5 pt-1.5 border-t border-dashed">
          {hasHours ? (
            <span className={`inline-flex items-center gap-0.5 text-[10px] ${item.estimate_hours != null && item.logged_hours > item.estimate_hours ? "text-[#991B1B]" : "text-muted-foreground"}`} title={`Logged / estimate${item.remaining_hours != null ? ` · ${fmtH(item.remaining_hours)} remaining` : ""}`} data-testid={`card-hours-${item.key}`}>
              <Clock className="h-3 w-3" />{fmtH(item.logged_hours || 0)}{item.estimate_hours != null ? ` / ${fmtH(item.estimate_hours)}` : ""}
            </span>
          ) : <span />}
          {item.price != null && <span className="text-[10px] text-[#065F46] bg-[#D1FAE5] rounded px-1 py-0.5 whitespace-nowrap" title="Price" data-testid={`card-price-${item.key}`}>{fmtMoney(item.price, currency)}</span>}
        </div>
      )}
    </div>
  );
}
